const allDigits = [
  ["0", "9"],
  ["\u06F0", "\u06F9"],
  ["\u0660", "\u0669"],
  ["\u07C0", "\u07C9"],
  ["\u0966", "\u096F"],
  ["\u09E6", "\u09EF"],
  ["\u0A66", "\u0A6F"],
  ["\u0AE6", "\u0AEF"],
  ["\u0B66", "\u0B6F"],
  ["\u0BE6", "\u0BEF"],
  ["\u0C66", "\u0C6F"],
  ["\u0CE6", "\u0CEF"],
  ["\u0D66", "\u0D6F"],
  ["\u0DE6", "\u0DEF"],
  ["\u0E50", "\u0E59"],
  ["\u0ED0", "\u0ED9"],
  ["\u0F20", "\u0F29"],
  ["\u1040", "\u1049"],
  ["\u1090", "\u1099"],
  ["\u17E0", "\u17E9"],
  ["\u1810", "\u1819"],
  ["\u1946", "\u194F"],
  ["\u19D0", "\u19D9"],
  ["\u1A80", "\u1A89"],
  ["\u1A90", "\u1A99"],
  ["\u1B50", "\u1B59"],
  ["\u1BB0", "\u1BB9"],
  ["\u1C40", "\u1C49"],
  ["\u1C50", "\u1C59"],
  ["\uA620", "\uA629"],
  ["\uA8D0", "\uA8D9"],
  ["\uA900", "\uA909"],
  ["\uA9D0", "\uA9D9"],
  ["\uA9F0", "\uA9F9"],
  ["\uAA50", "\uAA59"],
  ["\uABF0", "\uABF9"],
  ["\uFF10", "\uFF19"],
];

export function toEnDigit(string: number | string): string {
  let safeStr = String(string);
  for (let u = 0; u < allDigits.length; u += 1) {
    const re = new RegExp(`[${allDigits[u][0]}-${allDigits[u][1]}]`, "g");
    safeStr = safeStr.replace(re, (digit) => {
      let ret = "";
      for (let i = 0, len = digit.length; i < len; i += 1) {
        // first array in allDigits is english digits
        ret += String.fromCharCode(digit.charCodeAt(i) - allDigits[u][0].charCodeAt(0) + allDigits[0][0].charCodeAt(0));
      }
      return ret;
    });
  }
  return safeStr;
}

export function toFaDigit(string: number | string) {
  let safeStr = String(string);
  for (let u = 0; u < allDigits.length; u += 1) {
    const re = new RegExp(`[${allDigits[u][0]}-${allDigits[u][1]}]`, "g");
    safeStr = safeStr.replace(re, (digit) => {
      let ret = "";
      for (let i = 0, len = digit.length; i < len; i += 1) {
        // second array in allDigits is persian digits
        ret += String.fromCharCode(digit.charCodeAt(i) - allDigits[u][0].charCodeAt(0) + allDigits[1][0].charCodeAt(0));
      }
      return ret;
    });
  }
  return safeStr;
}
